'use client';

import { forwardRef } from 'react';
import { Breadcrumb, type BreadcrumbItem } from '@/components/molecules/Breadcrumb';
import styles from './PageMetadata.module.scss';

export interface PageMetadataProps {
  title: string;
  breadcrumbs?: BreadcrumbItem[];
  metadata?: {
    publishedAt?: string;
    updatedAt?: string;
    author?: string;
    readingTime?: string;
    category?: string;
    tags?: string[];
  };
  variant?: 'light' | 'dark';
  className?: string;
}

export const PageMetadata = forwardRef<HTMLDivElement, PageMetadataProps>(
  ({ title, breadcrumbs, metadata, variant = 'light', className = '' }, ref) => {
    return (
      <div ref={ref} className={`${styles.pageMetadata} ${styles[variant]} ${className}`}>
        <div className={styles.container}>
          {breadcrumbs && breadcrumbs.length > 0 && (
            <Breadcrumb items={breadcrumbs} className={styles.breadcrumb} />
          )}
          
          <h1 className={styles.title}>{title}</h1>
          
          {metadata && (
            <div className={styles.metadata}>
              {metadata.category && (
                <span className={styles.category}>{metadata.category}</span>
              )}
              {metadata.publishedAt && (
                <time className={styles.date} dateTime={metadata.publishedAt}>
                  {new Date(metadata.publishedAt).toLocaleDateString('ja-JP', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </time>
              )}
              {metadata.readingTime && (
                <span className={styles.readingTime}>{metadata.readingTime}</span>
              )}
              {metadata.author && (
                <span className={styles.author}>{metadata.author}</span>
              )}
            </div>
          )}
          
          {metadata?.tags && metadata.tags.length > 0 && (
            <div className={styles.tags}>
              {metadata.tags.map((tag) => (
                <span key={tag} className={styles.tag}>
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
);

PageMetadata.displayName = 'PageMetadata';

export default PageMetadata;